import { useEffect, useRef, useState } from 'react';
import Link from 'next/link';
import styles from '@features/cms/components/categories/CategoryTilesBlock/components/ButtonTile/ButtonTile.styles';
import { IButtonTile } from '@features/cms/typescript';
import Heading from '@components/Heading/Heading';
import Icon from '@components/icons/Icon';
import theme from '@styles/theme';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  tile: IButtonTile;
};
const ButtonTile = ({
  tile
}: PropsType) => {
  const {
    backgroundColor,
    textColor,
    title,
    description,
    url
  } = tile;
  const [descriptionRows, setDescriptionRows] = useState(2);
  const headerRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  const descriptionRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const updateDescription = () => {
      if (headerRef.current && contentRef.current && descriptionRef.current) {
        const headerHeight = headerRef.current.getBoundingClientRect().height;
        const contentHeight = contentRef.current.getBoundingClientRect().height;
        const descriptionFontSize = parseInt(window.getComputedStyle(descriptionRef.current).fontSize, 10) * 1.4;
        const descriptionTopMargin = parseInt(window.getComputedStyle(descriptionRef.current).marginTop, 10);
        const spaceForDescription = contentHeight - headerHeight - descriptionTopMargin;
        const rows = Math.floor(spaceForDescription / descriptionFontSize);
        setDescriptionRows(rows);
      }
    };
    updateDescription();
    if (typeof window !== 'undefined') window.addEventListener('resize', updateDescription);
    return () => window.removeEventListener('resize', updateDescription);
  }, [headerRef, contentRef, descriptionRef]);
  return <Link href={url ?? '/'} sx={styles.linkContainer}>
      <div sx={styles.container}>
        <div sx={styles.blockContainer(backgroundColor || theme.rawColors.accent700)}>
          <div sx={styles.content} ref={contentRef}>
            <div ref={headerRef}>
              <Heading h={5} headingType={3} color={textColor || theme.rawColors.neutralWhite} dangerouslySetInnerHTML={sanitizeHtml(title)} mobile />
            </div>
            <p sx={styles.description(textColor || theme.rawColors.neutralWhite, descriptionRows)} dangerouslySetInnerHTML={sanitizeHtml(description)} ref={descriptionRef} />
          </div>
          <div sx={styles.iconContainer}>
            <Icon icon="ArrowForward" color={textColor || theme.rawColors.neutralWhite} size={['24px', '32px', '40px']} />
          </div>
        </div>
      </div>
    </Link>;
};
export default ButtonTile;